export default __webpack_public_path__ + "static/media/ui_tap-variant-04.729cc15c.wav";